import { tenantApi } from '@/modules/tenant/services/tenantApi';
import type { Pipeline, PipelineFormData, PipelineStage, PipelineStagePayload } from '../types/crm.types';

export const pipelineApi = {
  // Get all pipelines (paginated)
  getAll: (params?: any) =>
    tenantApi.getPaginated<Pipeline>('/pipelines', { params }),

  // Get pipeline by ID
  getById: (id: string) =>
    tenantApi.getOne<Pipeline>(`/pipelines/${id}`),

  create: (pipelineData: PipelineFormData) =>
    tenantApi.postOne<Pipeline>('/pipelines', pipelineData),

  update: (id: string, pipelineData: Partial<PipelineFormData>) =>
    tenantApi.putOne<Pipeline>(`/pipelines/${id}`, pipelineData),

  delete: (id: string) =>
    tenantApi.deleteOne(`/pipelines/${id}`),

  // Add stage to pipeline
  addStage: (pipelineId: string, stageData: PipelineStagePayload) =>
    tenantApi.postOne<PipelineStage>(`/pipelines/${pipelineId}/stages`, stageData),

  // Update stage
  updateStage: (pipelineId: string, stageId: string, stageData: Partial<PipelineStagePayload>) =>
    tenantApi.putOne(`/pipelines/${pipelineId}/stages/${stageId}`, stageData),

  // Delete stage
  deleteStage: (pipelineId: string, stageId: string) =>
    tenantApi.deleteOne(`/pipelines/${pipelineId}/stages/${stageId}`),

  // Reorder stages
  reorderStages: (pipelineId: string, stageOrder: string[]) =>
    tenantApi.postAction(`/pipelines/${pipelineId}/stages/reorder`, { stage_order: stageOrder }),
};
